import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'

import { OlCommentInput } from '../../../../lib/types/models/ol/ol-input'
import { BaseFormProps } from '../../../../lib/types/utils'
import { getSubmitAction } from '../../../../lib/utils/buttons-config/validation-buttons-config'
import { FORM_MODE } from '../../../../utils/constants/form.constants'
import DateChip from '../../../elements/date-chip'
import { Form, FormControl, FormField, FormItem } from '../../../elements/forms/form'
import ControlledInput from '../../../elements/inputs/controlled-input'
import ValidationButtons from '../../../elements/validation-buttons'
import { OL_COMMENT_FORM_SCHEMA_VALIDATION } from '../utils'

type Props = BaseFormProps<OlCommentInput, true> & {
  className?: string
}

const OlCommentsForm = ({ className, defaultValues, ...validationButtonProps }: Props) => {
  const form = useForm<OlCommentInput>({
    resolver: zodResolver(OL_COMMENT_FORM_SCHEMA_VALIDATION),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className={className}>
          <DateChip date={new Date()} label="Date" />
          <div className="h-3" />
          <FormField
            control={form.control}
            name={'comment'}
            render={({ field }) => (
              <FormItem className={'flex-1'}>
                <FormControl>
                  <ControlledInput
                    required
                    type={'textarea'}
                    placeholder={'Votre commentaire...'}
                    label="Commentaire"
                    value={field.value}
                    onChange={field.onChange}
                  />
                </FormControl>
              </FormItem>
            )}
          />
        </div>

        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}

export default OlCommentsForm
